/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const getExportActivitiesQueryParamsSchema = z.object({
  Filters: z.string().optional(),
  SortOrder: z.string().optional(),
  PageNumber: z.coerce.number().int(),
  PageSize: z.coerce.number().int(),
});

/**
 * @description OK
 */
export const getExportActivities200Schema = z.any();

export const getExportActivitiesQueryResponseSchema = z.lazy(
  () => getExportActivities200Schema,
);
